import React, { useContext, useState } from 'react';
import './ReportStatus.css';
import { useQuery } from '@tanstack/react-query';
import ReportStatusInfo from './components/ReportStatusInfo';
import ClipLoader from 'react-spinners/ClipLoader';
// import { UserContext } from '../App';

const ReportStatus = () => {
  //   const { setUserDetails } = useContext(UserContext);
  const fetchReportStatus = async ({ queryKey }) => {
    const [_, code] = queryKey;
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_BACKEND_API;

    const response = await fetch(`${apiUrl}/issues?code=${code}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return response.json();
  };
  const [code, setCode] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(null);
  const [reportStatusData, setReportStatusData] = useState(null);
  const [reportStatusLoading, setReportStatusLoading] = useState(false);

  const closeMessage = () => {
    setShowMessage(false);
    setShowErrorMessage(null);
  };

  const { refetch } = useQuery(['reportStatus', code], fetchReportStatus, {
    enabled: false,
    onSuccess: (response) => {
      setReportStatusData(response);
      if (response.statusCode > 299 || response.statusCode < 200) {
        setShowErrorMessage(response.statusCode);
      }

      setShowMessage(true);
      setReportStatusLoading(false);
    },
    onError: (error) => {
      setShowErrorMessage(500);
      setShowMessage(true);
      setReportStatusLoading(false);
    },
  });

  const getReportStatus = () => {
    setReportStatusLoading(true);
    refetch();
  };

  return (
    <div id="report-status">
      <h4 className="first-instruction">
        Za provjeru statusa prijave unesite kod koji ste dobili prilikom prijave
        kvara.
      </h4>

      <input
        type="text"
        className="status-code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />

      <div className="check-status">
        <button
          className="check-status-button"
          disabled={reportStatusLoading}
          onClick={getReportStatus}
        >
          {reportStatusLoading ? (
            <ClipLoader
              color={'white'}
              loading={reportStatusLoading}
              size={20}
              data-testid="loader"
            />
          ) : (
            'Provjeri status'
          )}
        </button>
      </div>

      {showMessage && (
        <ReportStatusInfo
          closeMessage={closeMessage}
          reportStatusDetails={reportStatusData}
          showErrorMessage={showErrorMessage}
        />
      )}
    </div>
  );
};

export default ReportStatus;
